import type { LottieAnimationData } from './LottiePlayer.types'

export const DEFAULT_ASPECT_RATIO_CLASSNAME = 'aspect-[1]'

export const animationCache = new Map<string, LottieAnimationData>()
